import React from "react";
import { connect } from "react-redux";
import { Table } from "reactstrap";

const mapStateToProps = (state) => {
    return {
        getReglaNegocioDetail: state.ReglaNegocioReducer.getReglaNegocioDetail,
        errorReglaNegocioDetail: state.ReglaNegocioReducer.errorReglaNegocioDetail,
    };
};

const ReglaNegocioDetail = (props) => {
    const isEmpty       = props.getReglaNegocioDetail.length === 0;
    const reglanegocio  = Object.values(props.getReglaNegocioDetail);
    
    return (
        
        <Table striped>
            <tbody>


                {isEmpty ?
                    <div>There are no results</div>
                    :
                    reglanegocio.map(item =>
                        <>
                        <tr>
                            <td width="200">ID</td>
                            <td width="10">:</td>
                            <td>{item.idreglanegocio}</td>
                        </tr>

                        <tr>
                            <td width="200">Nombre</td>
                            <td width="10">:</td>
                            <td>{item.nombre}</td>
                        </tr>

                        <tr>
                            <td width="200">Descripción</td>
                            <td width="10">:</td>
                            <td>{item.descripcion}</td>
                        </tr>

                        <tr>
                            <td width="200">Tipo</td>
                            <td width="10">:</td>
                            <td>{item.tipo}</td>
                        </tr>

                        <tr>
                            <td width="200">Valor</td>
                            <td width="10">:</td>
                            <td>{item.valor}</td>
                        </tr>

                        <tr>
                            <td width="200">Operación</td>
                            <td width="10">:</td>
                            <td>{item.operacion}</td>
                        </tr>

                        <tr>
                            <td width="200">Asignación</td>
                            <td width="10">:</td>
                            <td>{item.asignar}</td>
                        </tr>

                        <tr>
                            <td width="200">Activo</td>
                            <td width="10">:</td>
                            <td>{(item.activo?"SI":"NO")}</td>
                        </tr>

                        <tr>
                            <td width="200">Fecha Alta</td>
                            <td width="10">:</td>
                            <td>{item.fechaalta}</td>
                        </tr>
                        </>
                        )
                }

            </tbody>
        </Table>

    );
};

export default connect(mapStateToProps, null)(ReglaNegocioDetail);
